import Dropdown from 'react-bootstrap/Dropdown';

export const FormulaSettingPublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">수식 설정</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-secondary w-100px h-38px">수정</button>
                    </div>
                </div>
                <div className="table_top">
                    <h6 className="table_stats">수식 설정 목록(<span>23</span>건)</h6>
                </div>
                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th style={{ width: "7.54%" }}></th>
                            <th style={{ width: "13.38%" }}>이름</th>
                            <th style={{ width: "42.1%" }}>수식</th>
                            <th style={{ width: "13.38%" }}>표시형식</th>
                            <th style={{ width: "13.38%" }}>집계 방식</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (<tr>
                            <td>
                                <button className="btn btn-default d-block m-auto">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_move_table.png"} alt="" />
                                </button>
                            </td>
                            <td>규격*</td>
                            <td>규격</td>
                            <td className="text-center">일반</td>
                            <td className="text-center">합계</td>
                            <td className="text-center">
                                <div className="d-flex align-items-center justify-content-center">
                                    <button className="btn btn-default btn_td">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon-hide-eye.png"} alt="" />
                                    </button>
                                    <Dropdown>
                                        <Dropdown.Toggle className="dots_dropdown" variant="link">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon-dots.png"} alt="" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item href="#/action-1">수식 숨기기</Dropdown.Item>
                                            <Dropdown.Item href="#/action-2">삭제하기</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </td>
                        </tr>))}
                    </tbody>
                </table>

            </div>

        </>
    );
}